import React from 'react';
import {
  Container,
  Typography,
  Box,
  Grid,
  Paper,
  Divider,
  Link,
  useTheme,
  alpha
} from '@mui/material';
import { useSEO } from '../hooks/useSEO';

const Contact = () => {
  const theme = useTheme();
  
  // 设置页面 SEO
  useSEO('contact');

  return (
    <Box sx={{ bgcolor: 'background.default', minHeight: '100vh' }}>
      {/* 英雄区域 */}
      <Box
        sx={{
          background: `linear-gradient(135deg, ${alpha(theme.palette.primary.main, 0.1)} 0%, ${alpha(theme.palette.secondary.main, 0.1)} 100%)`,
          py: 8,
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ textAlign: 'center', mb: 6 }}>
            <Typography 
              variant="h2" 
              sx={{ 
                mb: 3, 
                fontWeight: 700,
                background: `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
                backgroundClip: 'text',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}
            >
              联系我们
            </Typography>
            <Typography variant="h5" sx={{ color: 'text.secondary', lineHeight: 1.8 }}>
              获取专业的留学咨询服务，我们随时为您提供帮助
            </Typography>
          </Box>
        </Container>
      </Box>

      <Container maxWidth="lg" sx={{ py: 8 }}>
      <Grid container spacing={4}>
        {/* 中国办公室 */}
        <Grid item xs={12} md={6}>
          <Paper 
            sx={{ 
              p: 4, 
              borderRadius: 3,
              height: '100%',
              background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.primary.main, 0.05)} 100%)`,
              border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: theme.shadows[8]
              }
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#052391' }}>
              中国办公室
            </Typography>
            <Divider sx={{ mb: 3, borderColor: alpha(theme.palette.primary.main, 0.2) }} />
            <Box sx={{ mb: 3, borderRadius: 2, overflow: 'hidden', boxShadow: theme.shadows[2] }}>
              <iframe
                title="中国公司地图"
                src="https://j.map.baidu.com/15/_SD"
                width="100%"
                height="200"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
              ></iframe>
            </Box>
            <Box sx={{ space: 2 }}>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>办公地址：</strong> 合肥市包河区万达广场7号写字楼1805室 
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>联系电话：</strong> 0551-62888215
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>联系手机：</strong> +86 19956586698(微信同号)
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>联系邮箱：</strong> <Link href="mailto:xihangedu@qq.com" sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>xihangedu@qq.com</Link>
              </Typography>
            </Box>
          </Paper>
        </Grid>
        {/* 马来西亚办公室 */}
        <Grid item xs={12} md={6}>
          <Paper 
            sx={{ 
              p: 4, 
              borderRadius: 3,
              height: '100%',
              background: `linear-gradient(135deg, ${alpha(theme.palette.background.paper, 0.9)} 0%, ${alpha(theme.palette.secondary.main, 0.05)} 100%)`,
              border: `1px solid ${alpha(theme.palette.secondary.main, 0.1)}`,
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-4px)',
                boxShadow: theme.shadows[8]
              }
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 600, mb: 3, color: '#052391' }}>
              马来西亚办公室
            </Typography>
            <Divider sx={{ mb: 3, borderColor: alpha(theme.palette.secondary.main, 0.2) }} />
            <Box sx={{ mb: 3, borderRadius: 2, overflow: 'hidden', boxShadow: theme.shadows[2] }}>
              <iframe 
                src="https://www.google.com/maps/embed?pb=!1m16!1m12!1m3!1d1802.5236951414358!2d101.66469958838417!3d3.1716296819123078!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!2m1!1s%20Block%20B2-6-7%2CSolaris%20Dutamas%2C50480%20Kuala%20Lumpur%2CFederal%20Territory%20of%20Kuala%20Lumpur!5e1!3m2!1szh-CN!2s!4v1753620640164!5m2!1szh-CN!2s" 
                width="100%" 
                height="200" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </Box>
            <Box sx={{ space: 2 }}>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>办公地址：</strong> Block B2-6-7,Solaris Dutamas,50480 Kuala Lumpur,Federal Territory of Kuala Lumpur
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>联系电话：</strong> +(60)1135615210
              </Typography>
              <Typography variant="body1" sx={{ mb: 2, color: '#333' }}>
                <strong style={{ color: '#052391' }}>联系邮箱：</strong> <Link href="mailto:xihangedu@qq.com" sx={{ color: 'primary.main', textDecoration: 'none', '&:hover': { textDecoration: 'underline' } }}>xihangedu@qq.com</Link>
              </Typography>
            </Box>
          </Paper>
        </Grid>
      </Grid>
      </Container>
    </Box>
  );
};

export default Contact;
